let interval = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if (apElements){
    let swatchWithPrice = document.querySelectorAll('.apo-cutomize_swatch .avp-productoptionswatchwrapper > input');
    for(let item of swatchWithPrice) {
      if(item.checked) {
        item.parentElement.style.border = "2px solid #353c4e ";
      } else {
        item.parentElement.style.border = "unset";
      }
    }
  }
}, 100);

// Start: Subtotal = (selected size/fabric price + option extras) x quantity
// Updated Oct 2026. The old version saved the price once when the page opened,
// so the subtotal ignored size changes and quantity.
(function () {
  var formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });

  function toNumber(text) {
    var m = (text || '').replace(/,/g, '').match(/\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : 0;
  }

  function updateSubtotal() {
    var subtotal = document.querySelector('.productView-subtotal .money-subtotal');
    if (!subtotal) return;

    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var form = subtotal.closest('form');
    var idInput = form && form.querySelector('[name="id"]');
    if (!meta || !idInput) return;

    var variant = null;
    for (var i = 0; i < meta.variants.length; i++) {
      if (String(meta.variants[i].id) === String(idInput.value)) { variant = meta.variants[i]; break; }
    }
    if (!variant) return;

    var base = variant.price / 100;

    var extras = 0;
    var extrasBox = document.getElementById('avp-productoption-total-add');
    var extrasPrice = document.querySelector('.avp-productoption-totalpriceadd');
    if (extrasBox && extrasPrice && extrasBox.offsetParent !== null) extras = toNumber(extrasPrice.textContent);

    var group = subtotal.closest('.productView-group');
    var qtyInput = group && group.querySelector('input[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

    var text = formatter.format((base + extras) * qty);
    if (subtotal.textContent !== text) subtotal.textContent = text;
  }

  setInterval(updateSubtotal, 150);
})();
// End: Subtotal
